<template>
    <section id="mainContainer">
       <adminHeader></adminHeader>
       <section class="admin-mid-container">
           <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
               <adminNavigation></adminNavigation>
               <section class="admin-right-sidebar">
                   <div class="admin-right-sidebar-in">
                       <div class="admin-right-sidebar-in-top">
                           <div class="admin-custom-row">
                               <div class="admin-right-sidebar-in-top-left">
                                   <h1>
                                       {{constants.MANAGE_CONTACT_US_TEXT}} ({{counts}})
                                   </h1>
                            
                               </div>

                               <div class="admin-right-sidebar-in-top-right">
                                   <div class="admin-search-box">
                                       <input id="seachContactInput" type="text" placeholder="Search" v-model="searchedText"
                                       @keyup.enter="fetchContacts(status,limit,skip), fetchCounts(searchedText)" />
                                   </div>
                                   <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedContacts.length > 1">
                                       <div class="tags">
                                         <ul>
                                           <li>
                                             <span>{{ selectedContacts.length }} entries selected</span>
                                             <button id="tagCloseBtn" @click="selectedContacts = [], selectAll = false"></button>
                                           </li>
                                         </ul>
                                       </div>
                                       <div class="delete-all-btn-link">
                                         <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal" data-bs-target="#deletePop"
                                           @click="setDeleteMode('all')">
                                           {{ constants.DELETE_ALL_BUTTON }}
                                         </button>
                                       </div>
                                     </div>
                                   
                               </div>
                           </div>
                       </div>
                    
                       <div class="admin-item-list-section admin-contact-section" v-if="contacts.length > 0">
                           <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                               <div class="admin-item-list-section-scroll">
                               <div class="admin-item-list-top">
                                   <div class="admin-item-list-row">
                                       <div class="admin-item-checkbox">
                                           <div class="admin-checkbox-input">
                                               <input name="cssCheckbox" id="selectAll" type="checkbox" class="css-checkbox"
                           @change="toggleSelectAll" :checked="selectAll === true">
                         <label for="selectAll"></label>
                                           </div>
                                       </div>
                                       <div class="admin-item-contact-name"> {{constants.NAME_LABEL}}</div>
                                       <div class="admin-item-contact-email">{{constants.EMAIL_LABEL}}</div>
                                       <div class="admin-item-contact-subject">{{constants.SUBJECT_LABEL}}</div>
                                       <div class="admin-item-contact-message">{{constants.MESSAGE_LABEL}} </div>
                                       <div class="admin-item-sm-actions">{{constants.ACTIONS_LABEL}}</div>
                                   </div>
                               </div>
                               <div class="admin-item-list-btm">
                                <div ref="sortableList">
                                   <div  v-for="(contact, index) in contacts" :key="contact.id"
                                         :class="['admin-item-box', { 'show-edit-item': editFormSubmitted }]">
                                       <div class="admin-item-box-top">
                                           <div class="admin-item-list-row">
                                               <div class="admin-item-checkbox">
                                                   <div class="admin-checkbox-input">
                                                       <input name="cssCheckbox" :id="'demo_opt_' + contact.id" type="checkbox"
                                                       class="css-checkbox" @change="toggleContactSelection(contact.id)"
                                                       :checked="selectedContacts.includes(contact.id)">
                                                     <label :for="'demo_opt_' + contact.id"></label>
                                                   </div>
                                               </div>
                                               <div class="admin-item-contact-name text-limit">
                                                   {{contact.name}}
                                               </div>
                                               <div class="admin-item-contact-email">{{contact.email}}</div>
                                               <div class="admin-item-contact-subject text-limit">
                                                   {{contact.subject}}
                                               </div>
                                               <div class="admin-item-contact-message text-limit">
                                                   {{contact.message}}
                                               </div>
                                               <div class="admin-item-sm-actions"> 
                                                   <ul class="admin-action-link">
                                                       <li><button id="contactPgEditBtn" class="editBtn" @click="editContact(index)">View</button></li>
                                                       <li><button id="contactPgDeleteBtn" class="hide-row-btn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('single', contact.id)">{{constants.DELETE_BUTTON}}</button></li>
                                                   </ul>
                                               </div>
                                           </div>
                                       </div>
                                       <div class="admin-item-box-btm admin-contact-btn-row" v-if="contact.editing">
                                           <div class="admin-contact-details">
                                              <div class="custom-row">
                                                 <div class="admin-contact-details-left">
                                                   <div class="admin-contact-box">
                                                       <label>{{constants.NAME_LABEL}}</label>
                                                       <p>{{contact.name}}</p>
                                                   </div>
                                                   <div class="admin-contact-box">
                                                       <label>{{constants.EMAIL_LABEL}}</label>
                                                       <p>{{contact.email}}</p>
                                                   </div>
                                                   <div class="admin-contact-box">
                                                       <label>{{constants.SUBJECT_LABEL}}</label>
                                                       <p>{{contact.subject}}</p>
                                                   </div>
                                                 </div>
                                                 <div class="admin-contact-details-right">
                                                   <div class="admin-contact-box">
                                                       <label>{{constants.MESSAGE_LABEL}}</label>
                                                       <p>{{contact.message}}</p>
                                                   </div>
                                                 </div>
                                              </div>
                                              <div class="btn-set-left-align">
                                               <button id="deleteBtn" class="admin-btn-link-primary" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('single', contact.id)">
                                                   {{constants.DELETE_BUTTON}}
                                               </button>
                                               <button  id="closeBtn" class="admin-btn-link-primary addNewCancel">
                                                   {{constants.CLOSE_BUTTON}}
                                               </button>
                                           </div>
                                           </div>
                                       </div>
                                   </div>
                                   </div>
                               </div>
                           </div>  
                           </div>
                           <div class="admin-pagination-section">
                               <div class="custom-row">
                                 <div class="item-show-selectbox">
                                   <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                     <option value="10">10</option>
                                     <option value="20">20</option>
                                     <option value="50">50</option>
                                     <option value="100">100</option>
                                   </select>
                                   <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                 </div>
                                 <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                   <ul>
                                     <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                       <a href="#" class="pagination-previous"></a>
                                     </li>
                                     <li v-for="page in visiblePages" :key="page" @click="changePage(page)" v-if="totalPages != 1">
                                       <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                     </li>
                                     <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                       <a href="#" class="pagination-next"></a>
                                     </li>
                                   </ul>
                                 </div>
                               </div>
                             </div>
                           </div>
                           <div v-else>
              <p>No data to display</p>
            </div>
                         </div>
               </section>
           </div>
       </section>
       <footer class="admin-site-footer">
           <div class="container">
             {{ constants.COPYRIGHT_TEXT }}
           </div>
         </footer>

               <!-------------------------- Delete Pop Start --------------------------------->

               <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
               aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
               <div class="modal-dialog" role="document">
                 <div class="modal-content">
                   <div class="confirmation-popup-icon">
                     <i>
                       <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                     </i>
                   </div>
                   <div class="confirmation-popup-mid">
                     <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                   </div>
                   <div class="confirmation-popup-btm">
                     <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                       {{ constants.NO_BUTTON }}
                     </button>
                     <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="confirmDelete">
                       {{ constants.YES_BUTTON }}
                     </button>
                   </div>
                 </div>
               </div>
             </div>
         
   </section>
</template>
<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { API_BASE_URL } from "@/config/api.config";
import Sortable, { SortableEvent } from 'sortablejs';
import Swal from 'sweetalert2';


interface Contact {
  id: number;
  name: string;
  email: string;
  subject: string;
  message: string;
  status: number;
  editing?: boolean;
  Created_at?: string
  position: number; // Add position field
}

export default defineComponent({
  name: "Contact",
  data() {
    return {
      constants,
      status: 1,
      limit: 10,
      skip: 0,
      selectAll: false,
      editFormSubmitted: false,
      contacts: [] as Contact[],
      selectedContacts: [] as number[],
      totalPages: 0,
      currentPage: 1,
      searchedText: '',
      searchTempVar: '',
      counts: 0,
      contactToDelete: null as number | null,
      deleteMode: 'all' as 'all' | 'single',
      isDragging: false, // Add for drag state
      sortableInstance: null as Sortable | null // Add for SortableJS instance
    };
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  computed: {
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  components: {
    adminHeader,
    adminNavigation
  },
  created() {
    this.fetchCounts();
    this.fetchContacts();
  },
  mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
  },
  methods: {
    setDeleteMode(mode: any, contactId?: number) {
      this.deleteMode = mode;
      if (contactId !== undefined) {
        this.contactToDelete = contactId;
      }
    },
    confirmDelete() {
      if (this.deleteMode === 'all') {
        this.deleteSelectedContacts(); 
      } else if (this.deleteMode === 'single') {
        this.deleteContact();
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchContacts(this.status, this.limit,(this.currentPage - 1) * this.limit);
        this.selectAll = false
        this.selectedContacts = []
      }
    },

    toggleContactSelection(contactId: number) {
      if (this.selectedContacts.includes(contactId)) {
        this.selectedContacts = this.selectedContacts.filter(id => id !== contactId);
      } else {
        this.selectedContacts.push(contactId);
      }


    },
    toggleSelectAll() {
      if (this.selectAll === true) {
        this.selectedContacts = [];
        this.selectAll = false
      } else {
        this.selectedContacts = this.contacts.map(contact => contact.id);
        this.selectAll = true
      }
    },

    
    async deleteSelectedContacts() {
      try {
        await axios.delete(`${API_BASE_URL}/contactus/bulk_delete/`, { data: { ids: this.selectedContacts } });
        this.contacts = this.contacts.filter(contact => !this.selectedContacts.includes(contact.id));
        this.selectedContacts = [];
        this.fetchContacts()
        if (this.contacts.length === 0) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          this.fetchContacts();
          this.selectAll = false
          this.fetchCounts()
        }
      } catch (error) {
        console.error('Error deleting contacts:', error);
      }
    },
    

    handleLimitChange() {
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts / this.limit);
      this.selectAll = false
      this.selectedContacts = [];
      this.fetchContacts( this.status,this.limit);
    },
    async switchView() {
        this.totalPages = Math.ceil(this.counts / this.limit);
      this.currentPage = 1;
      this.selectAll = false;
      this.fetchContacts()
      
    },
    async fetchContacts(status = 1, limit = 10, skip = 0) {
      let url = `${API_BASE_URL}/contactus/`;
      const params = new URLSearchParams();
      if (status === 1) {
        params.append('status', '1');
      }
      if (this.searchedText) {
        if (!this.searchTempVar) {
          this.limit = 10;
          this.currentPage = 1;
        }
        this.searchTempVar = this.searchedText;
      }
      if (!this.searchedText) {
        if (this.searchTempVar) {
          this.currentPage = 1;
          this.limit = 10;
          this.searchTempVar = '';
        }
        params.append('limit', limit.toString());
        params.append('skip', skip.toString());
      }
      if (this.searchedText) {
        params.append('limit', this.limit.toString());
        params.append('skip', skip.toString());
        params.append('searchedText', this.searchedText);
      }
      params.append('sort_by', 'position'); // Sort by position by default

      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.contacts = response.data;
        this.setupSortable(); // Reinitialize SortableJS after data fetch
      } catch (error) {
        console.error('Error fetching contacts:', error);
      }
    },
    
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/contactus/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';
        const response = await axios.get(`${baseUrl}${queryParam}1&status=1`);
        this.counts = response.data.count
        // this.totalPages = Math.ceil(this.counts / 10);
        this.switchView()
      } catch (error) {
        console.error('Error fetching contact counts:', error);
      }
    },


    editContact(index: number) {
      this.contacts.forEach((contact, i) => {
        contact.editing = i === index;
      });
      this.editFormSubmitted = true;
    },


    async deleteContact() {
      try {
        await axios.delete(`${API_BASE_URL}/contactus/${this.contactToDelete}/`);
        this.editFormSubmitted = false;
        this.fetchContacts();
        this.fetchCounts();
        (this.$refs.dummyButton as HTMLElement).click();
      } catch (error) {
        console.error('Error deleting contact:', error);
      }
    },
    setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, a, .admin-item-box-btm', // Prevent dragging on view form
          preventOnFilter: true,
          disabled: this.editFormSubmitted, // Disable when viewing
          onStart: () => {
            this.isDragging = true;
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newContactsData = [...this.contacts];
            const [movedItem] = newContactsData.splice(oldIndex, 1);
            newContactsData.splice(newIndex, 0, movedItem);

            // Update positions locally
            newContactsData.forEach((item, index) => {
              item.position = index + 1; // 1-based positioning
            });

            // Update reactive property
            this.contacts = newContactsData;

            // Prepare data for backend sync
            const reorderedItems = newContactsData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              await axios.post(`${API_BASE_URL}/contactus/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchContacts(this.status, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchContacts(this.status, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });
      });
    }
  }
});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>